
import main from '@/views/main'
import Index from '@/views/index'
import jdyrole from '@/common/jdyrole';
export const routes = [{
  path: '/',
  redirect: '/template',
  component: main,
  children: [{
    path: '/company',
    redirect: 'company/message-list',
    component: Index,
    name: 'company',
    children: [{
      path: '/company/message-list',
      components: { default: () => import('@/views/company-introduce/company-introduce') },
      name: 'messageList',
      meta: {
        title: '公司信息管理',
        requiresAuth: true,
        requiresRole: [jdyrole.superadmin]
      }
    }]
  },{
    path: '/template',
    redirect: 'template/article-list',
    component: Index,
    name: 'template',
    children: [{
      path: '/template/article-list',
      components: { default: () => import('@/views/template-management/article-template-list') },
      name: 'articleList',
      meta: {
        title: '文章模板列表',
        requiresAuth: true,
        requiresRole: [jdyrole.superadmin]
      }
    },{
      path: '/template/product-list',
      components: { default: () => import('@/views/template-management/product-template-list') },
      name: 'productList',
      meta: {
        title: '产品模板列表',
        requiresAuth: true,
        requiresRole: [jdyrole.superadmin]
      }
    },{
      path: '/template/local-list',
      components: { default: () => import('@/views/template-management/local-template-list') },
      name: 'localList',
      meta: {
        title: '局部模板列表',
        requiresAuth: true,
        requiresRole: [jdyrole.superadmin]
      }
    },{
      path: '/template/classification',
      components: { default: () => import('@/views/classification-management/') },
      name: 'localList',
      meta: {
        title: '模板分类',
        requiresAuth: true,
        requiresRole: [jdyrole.superadmin]
      }
    }]
  },{
    path: '/theme',
    redirect: '/theme/theme-list',
    component: Index,
    name: 'themeList',
    children: [{
      path: '/theme/theme-list',
      components: { default: () => import('@/views/theme-managment/theme-list') },
      name: 'themeList',
      meta: {
        title: '主题管理',
        requiresAuth: true,
        requiresRole: [jdyrole.superadmin]
      }
    },{
      path: '/theme/theme-set',
      components: { default: () => import('@/views/theme-managment/theme-set') },
      name: 'themeSet',
      meta: {
        title: '色系配置',
        requiresAuth: true,
        requiresRole: [jdyrole.superadmin]
      }
    }]
  }]
},{
  path: '/template/editor',
  components: { default: () => import('@/views/template-management/template-editor') },
  name: 'articleDetails',
  meta: {
    title: '模板编辑器',
    requiresAuth: true,
    requiresRole: [jdyrole.superadmin]
  }
},{
  path: '/template/preview',
  components: { default: () => import('@/views/template-preview') },
  name: 'preview',
  meta: {
    title: '模板预览',
    requiresAuth: false,
    requiresRole: [jdyrole.superadmin]
  }
},{ 
  path: '/norole.html', 
  components: { default: () => import('@/views/oidc/norole') }, 
  meta: { title: '拒绝访问' } 
},{ 
  path: '/jump', 
  components: { 
    default: () => import('@/views/oidc/jump') 
  } 
},{ 
  path: '/oidc/callback.html', 
  components: { default: () => import('@/views/oidc/callback') } 
},{ 
  path: '/oidc/silent.html', 
  components: { default: () => import('@/views/oidc/silent') } 
}]



// WEBPACK FOOTER //
// ./src/router/routes.js